/* STRAZNIK: kazda sekcja PDP ma wlasny silnik (inne pasma, inne mg) i wykonuje
   sie inline PRZED tym plikiem (defer). Bez straznika oba ruszylyby razem i kazdy
   przelacznik dostalby dwa nasluchy - dokladnie ten blad zlapalismy na OMEDZE
   03.09. Na stronach bez PDP (koszyk, 404) ten plik obsluguje burger. */
if(!window.__mdInit){window.__mdInit=1;
document.addEventListener('DOMContentLoaded',function(){
function fmt(v){return '$'+Number(v).toFixed(2)}
function show(id,on){var e=document.getElementById(id);if(e)e.classList.toggle('vHide',!on)}
document.querySelectorAll('.mdj .tabRow button').forEach(function(b){
  b.addEventListener('click',function(){
    document.querySelectorAll('.mdj .tabRow button').forEach(function(x){x.classList.remove('on')});
    b.classList.add('on');
    ['t0','t1','t2','t3','t4'].forEach(function(id){show(id,id===b.dataset.t)});
  });
});
var root=document.querySelector('#mdj [data-sub-default], .mdj[data-sub-default]');
var subDefault=!root||root.dataset.subDefault!=='false';
var BANDS={1:{label:'Under 45 lb',doses:1},2:{label:'45 - 89 lb',doses:2},3:{label:'90 lb +',doses:3}};
/* SELLING PLANY: karty .plan z data-plan przychodza z Liquid (selling_plan_allocations).
   Bez nich subskrypcja nie istnieje po stronie Shopify - toggle znika, a przycisk
   mowi "Add to Cart" w cenie katalogowej. Wczesniej toggle pokazywal rabat, ktorego
   koszyk nie naliczal. */
var hasPlans=!!document.querySelector('.mdj #mdjPlans .plan[data-plan]:not([data-plan=""])');
/* CYKL DOSTAWY W DNIACH. Obiekt selling_plan w Liquid NIE ma delivery_policy (to bylo
   zalozenie w pierwotnym buy boxie i na zywo dawalo data-days=""). Sa za to nazwa
   ("Deliver every 2 months, 20% off") i options[0].value ("2 months") - stad liczymy:
   day=1, week=7, month=30, year=365; brak liczby = 1. */
(function(){ var U={day:1,week:7,month:30,year:365};
  document.querySelectorAll('.mdj #mdjPlans .plan[data-plan]').forEach(function(p){
    if(+p.dataset.days>0) return;
    var t=(p.dataset.opt||'')+' '+(p.dataset.name||'');
    var m=t.match(/(\d+)?\s*(day|week|month|year)/i);
    if(m) p.dataset.days=String((+m[1]||1)*U[m[2].toLowerCase()]);
  }); })();
var state={band:2,doses:2,picked:false,sub:subDefault&&hasPlans};
function dosesFor(lb){return Math.max(1,Math.ceil(lb/45))}
function currentPlan(){return document.querySelector('.mdj #mdjPlans .plan.on')||document.querySelector('.mdj #mdjPlans .plan')}

/* JOINTS: etykieta mowi 1 plaska miarka na 20 kg = 44,09 lb. Progi stoja na
   45 i 90 lb - okragle liczby, decyzja Agi 03.09. Zaokraglenie W GORE, wiec
   pies 44,1-45,0 lb bierze jedna miarke tam, gdzie etykieta dalaby dwie;
   okno rozbieznosci ma jeden funt.
   Wczesniej stalo tu 40 / 80 lb z uzasadnieniem, ze "zadnemu psu nie brakuje
   miarki" - bylo odwrotnie, nizszy prog daje miarke WCZESNIEJ niz etykieta. */
function measuresFor(lb){ if(lb<45) return 1; if(lb<=90) return 2; return 3; }
/* 87 g : 1,45 g na miarke = 60 miarek. Zalozenie robocze - specyfikacja producenta
   podaje tylko mase netto 87 g i dawke 1 miarka / 20 kg masy psa. */
var MEASURES_PER_JAR = 60;

/* DRABINKA OFERTY
   Klient wybiera LICZBE SLOIKOW (1 / 2 / 3), nie cykl dostawy. Cykl wynika z wagi psa:
   sloik 87 g = 60 miarek, wiec starcza na 60 / 30 / 20 dni. Dla kazdego progu szukamy
   selling planu, ktorego czestotliwosc dostawy odpowiada zapasowi z tej liczby sloikow.
   Progi rabatu 20 / 25 / 30% sa te same, jakie sa w tabeli oferty. */
/* Jedna plakietka na drabinke: "Recommended choice". Zadnych "Most popular"
   ani "Best value" - decyzja z 02.09, ten sam uklad co na GUT. */
/* 07.09: drabinka zalezna od pasma wagi - jak na GUT i DENTAL. Pies 90 lb+ zjada
   3 miarki dziennie, sloik starcza 20 dni, wiec 1 sloik nie ma sensu handlowego -
   zaczynamy od 2 i dokladamy 5 sloikow z rabatem 40% (plan "14 weeks", 98 dni).
   Dopiero tu cena "from $29.99 per jar" z home jest osiagalna na kazdym produkcie. */
var TIERS_BY_BAND={
  1:[{jars:1,pct:20,rec:true},{jars:2,pct:25},{jars:3,pct:30}],
  2:[{jars:1,pct:20},{jars:2,pct:25,rec:true},{jars:3,pct:30}],
  3:[{jars:2,pct:25},{jars:3,pct:30,rec:true},{jars:5,pct:40}]
};
function tiersNow(){ return TIERS_BY_BAND[state.band]||TIERS_BY_BAND[2]; }
function allPlans(){ return [].slice.call(document.querySelectorAll('.mdj #mdjPlans .plan')); }
function planPct(p){ var l=+(p.dataset.list||p.dataset.unit),u=+p.dataset.unit; return l>0?Math.round((l-u)/l*100):0; }
function jarDays(){ return Math.round(MEASURES_PER_JAR/state.doses); }

function buildLadder(){
  var dd=jarDays(), all=allPlans();
  if(!all.length) return;
  all.forEach(function(p){ p.style.display='none'; p.removeAttribute('data-jars'); });
  var taken=[], box=document.querySelector('.mdj #mdjPlans');
  tiersNow().forEach(function(t){
    var target=t.jars*dd, tol=Math.max(7,target*0.2);
    /* najpierw plany o wlasciwym progu rabatu, dopiero potem jakiekolwiek w tolerancji */
    function pick(matchPct){
      var best=null, bd=1e9;
      all.forEach(function(p){
        if(taken.indexOf(p)>-1) return;
        var d=+p.dataset.days; if(!d) return;
        if(matchPct && Math.abs(planPct(p)-t.pct)>1) return;
        var diff=Math.abs(d-target); if(diff>tol) return;
        if(diff<bd){ bd=diff; best=p; }
      });
      return best;
    }
    var best=pick(true)||pick(false);
    if(!best) return;
    taken.push(best);
    best.style.display='';
    best.dataset.jars=t.jars;
    if(box) box.appendChild(best);          /* kolejnosc w kolumnie: 1 -> 2 -> 3 sloiki */
    var rb=best.querySelector('[data-rib]');
    /* plakietka widoczna takze przy zakupie jednorazowym - inaczej rekomendacja
       znikala po przelaczeniu subskrypcji, a karta zostawala zaznaczona */
    if(rb){ rb.textContent=t.rec?'Recommended choice':''; rb.classList.toggle('b',!!t.rec); rb.style.display=t.rec?'':'none'; }
    best.classList.toggle('rec',!!t.rec);
  });
  /* awaryjnie: gdy zaden plan nie pasuje do wagi psa, pokaz co jest i policz sloiki z cyklu */
  if(!taken.length){
    all.forEach(function(p){
      p.style.display='';
      p.dataset.jars=Math.max(1,Math.ceil((+p.dataset.days||28)/dd));
      var rb=p.querySelector('[data-rib]'); if(rb) rb.style.display='none';
      p.classList.remove('rec');
    });
    taken=all;
  }
  /* zaznaczony plan musi byc widoczny */
  var vis=taken.filter(function(p){return p.style.display!=='none';});
  if(!vis.length) return;
  /* Rekomendacja jest zaznaczona z automatu i pozostaje zaznaczona po zmianie
     pasma wagi. Wybor klienta (state.picked) ma pierwszenstwo dopiero po kliku. */
  var on=vis.filter(function(p){return p.classList.contains('on');});
  if(!on.length || !state.picked){
    var rt=tiersNow().filter(function(t){return t.rec;})[0];
    var pick=rt?vis.filter(function(p){return +p.dataset.jars===rt.jars;})[0]:null;
    if(!pick) pick=vis[1]||vis[0];
    all.forEach(function(p){p.classList.remove('on')});
    pick.classList.add('on');
  }
}
function applyRecommendation(){ buildLadder(); }

function render(){
  buildLadder();
  var el=currentPlan(); if(!el)return;
  var isOnce = !state.sub || !el.dataset.plan;
  var list = +(el.dataset.list||el.dataset.unit);
  var unit = isOnce ? list : +el.dataset.unit;
  var dailyDays = jarDays();                       // dni, na ktore starcza jeden sloik
  var jars = +el.dataset.jars || 1;                // liczba sloikow w dostawie - to wybiera klient
  var total = unit*jars;
  var pct = list>0 ? Math.round((list-unit)/list*100) : 0;

  /* opisy planow: liczba sloikow, dni zapasu, cena za dzien */
  allPlans().forEach(function(p){
    if(p.style.display==='none') return;
    var l=+(p.dataset.list||p.dataset.unit), u=(state.sub&&p.dataset.plan)?+p.dataset.unit:l;
    var j=+p.dataset.jars||1, pp=Math.round((l-u)/l*100);
    var sup=j*dailyDays, cd=+p.dataset.days||sup;
    var supTxt = sup>=60 ? Math.round(sup/30)+' months of supply' : sup+' days of supply';
    p.querySelector('[data-nm]').innerHTML = j+' jar'+(j>1?'s':'')+
      ' <span style="font-weight:500;color:#4A5670"> - '+supTxt+'</span>';
    var slot=p.querySelector('[data-save-slot]');
    slot.textContent = (state.sub&&p.dataset.plan&&pp>0) ? 'Save '+pp+'%' : '';
    slot.style.display = (state.sub&&p.dataset.plan&&pp>0) ? '' : 'none';
    p.querySelector('[data-meta]').innerHTML =
      fmt(u)+' per jar · <b>'+fmt(u*j)+'</b>'+((state.sub&&p.dataset.plan)?' every '+Math.round(cd/7)+' weeks':' one-time')+' · '+fmt(u/dailyDays)+' / day'+
      (sup>=90?' <span style="color:#1E8A4E;font-weight:600">· full protocol</span>':'');
    var fq=p.querySelector('[data-freq]');
    if(fq){ fq.textContent='Deliver every '+Math.round(cd/7)+' weeks'; fq.style.display = (state.sub&&p.dataset.plan) ? '' : 'none'; }
    var rb=p.querySelector('[data-rib]');
    /* rekomendacja jest tak samo wazna przy zakupie jednorazowym - nie chowamy jej */
    if(rb) rb.style.display = rb.textContent ? '' : 'none';
  });
  /* pole wagi */
  var wo=document.getElementById('wOut');
  if(wo)wo.innerHTML='<b>'+(1426*state.doses).toLocaleString('en-US')+' mg of actives a day.</b> One 87 g jar lasts him '+dailyDays+' days.';

  /* koszyk */
  var qf=document.getElementById('mdjQty'); if(qf)qf.value=jars;
  var vf=document.getElementById('mdjVid'); if(vf&&el.dataset.vid)vf.value=el.dataset.vid;
  var pf=document.getElementById('mdjPlan');
  if(pf){ var pid=el.dataset.plan||''; if(!isOnce&&pid){pf.value=pid;pf.disabled=false;} else {pf.value='';pf.disabled=true;} }
  var wf=document.getElementById('mdjWeight'); if(wf)wf.value=BANDS[state.band].label;
  var df=document.getElementById('mdjDoses'); if(df)df.value=state.doses;

  document.getElementById('ctaBtn').textContent=(isOnce?'Add to Cart - ':'Subscribe & Save - ')+fmt(total);
  var bb=document.getElementById('bBtn'); if(bb)bb.textContent='Choose plan - '+fmt(total);
  var cs=document.getElementById('ctaSub');
  if(cs)cs.textContent=isOnce?"60-day money back · open jar, half-empty jar, doesn't matter":(cs.dataset.note||'Cancel anytime.');

  /* najtansza cena za sloik - informacja, nie ukrywamy jej */
  var floorEl=document.getElementById('mdjFloor');
  if(floorEl){
    var vis=allPlans().filter(function(p){return p.style.display!=='none';});
    if(vis.length&&state.sub){
      var best=vis.reduce(function(a,b){ return (+b.dataset.unit < +a.dataset.unit) ? b : a; });
      if(best===el){ floorEl.innerHTML=''; }
      else {
        var bu=+best.dataset.unit, bj=+best.dataset.jars||1, bw=Math.round((+best.dataset.days||0)/7);
        floorEl.innerHTML='Lowest price per jar is <b>'+fmt(bu)+'</b> - '+bj+' jar'+(bj>1?'s':'')+' every '+bw+' weeks, '+fmt(bu*bj)+' a delivery.';
      }
    }
  }

  /* tabela składu: na dobę */
  document.querySelectorAll('.mdj [data-mg]').forEach(function(c){
    var v=(+c.dataset.mg)*state.doses;
    c.textContent=(v>=1000?v.toLocaleString('en-US'):v)+' mg';
  });
  var gaHd=document.getElementById('gaHd');
  if(gaHd)gaHd.textContent='ONE 1.45 G MEASURE · '+BANDS[state.band].label.toUpperCase()+': '+state.doses+' MEASURE'+(state.doses>1?'S':'')+' A DAY';
}

document.querySelectorAll('.mdj #mdjPlans .plan').forEach(function(el){
  el.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelectorAll('.mdj #mdjPlans .plan').forEach(function(x){x.classList.remove('on')});
    el.classList.add('on'); state.picked=true; render();
  });
});
document.querySelectorAll('.mdj #mdjBands .size').forEach(function(b){
  b.addEventListener('click',function(){
    document.querySelectorAll('.mdj #mdjBands .size').forEach(function(x){x.classList.remove('on')});
    b.classList.add('on');
    state.band=+b.dataset.band; state.doses=BANDS[state.band].doses;
    state.picked=false;   /* nowe pasmo = nowa rekomendacja, znowu zaznaczona */
    applyRecommendation(); render();
  });
});
var subTg=document.getElementById('mdjSub');
if(subTg&&!hasPlans){ subTg.style.display='none'; subTg=null; }
if(subTg){
  var flip=function(){ state.sub=!state.sub; subTg.classList.toggle('on',state.sub); subTg.setAttribute('aria-checked',state.sub); render(); };
  subTg.setAttribute('aria-checked',state.sub);
  subTg.classList.toggle('on',state.sub);
  subTg.addEventListener('click',flip);
  subTg.addEventListener('keydown',function(e){ if(e.key===' '||e.key==='Enter'){e.preventDefault();flip();} });
}

state.doses=BANDS[state.band].doses;
document.querySelectorAll('.mdj .filters span').forEach(function(s){
  s.addEventListener('click',function(){
    document.querySelectorAll('.mdj .filters span').forEach(function(x){x.classList.remove('on')});
    s.classList.add('on');
  });
});
document.querySelectorAll('.mdj .rail .th').forEach(function(t){
  t.addEventListener('click',function(){
    document.querySelectorAll('.mdj .rail .th').forEach(function(x){x.classList.remove('on')});
    t.classList.add('on');
  });
});
applyRecommendation();
render();

/* nawigacja kotwicowa: odsloniecie po zejsciu z hero, bez zabierania miejsca nad buy boxem */
(function(){
  var nav=document.querySelector('.mdj .anav'); if(!nav) return;
  var hero=document.querySelector('.mdj .hero');
  function upd(){
    var trigger = hero ? hero.getBoundingClientRect().bottom : 400;
    nav.classList.toggle('show', trigger < 0);
  }
  upd(); window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd);
})();

/* opinie: dzialajace filtry + licznik. Dziala w kazdej sekcji, ktora ma .filters i .quotes */
(function(){
  document.querySelectorAll('.mdj .filters').forEach(function(box){
    var wrap=box.closest('section')||document;
    var quotes=wrap.querySelector('.quotes'); if(!quotes) return;
    var chips=[].slice.call(box.querySelectorAll('span'));
    var cards=[].slice.call(quotes.querySelectorAll('.q'));
    if(!chips.length||!cards.length) return;
    function has(c,f){ return (c.dataset.tags||'').split(' ').indexOf(f)>-1; }
    chips.forEach(function(c){
      var f=c.dataset.f;
      c.addEventListener('click',function(){
        chips.forEach(function(x){x.classList.remove('on')});
        c.classList.add('on');
        cards.forEach(function(k){ k.style.display=(!f||f==='all'||has(k,f))?'':'none'; });
      });
    });
  });
})();

/* tabela dawek: rozwijana karta badania bez wychodzenia ze strony */
(function(){
  var btns=[].slice.call(document.querySelectorAll('.mdj .evBtn[data-ev]'));
  if(!btns.length) return;
  btns.forEach(function(b){
    b.addEventListener('click',function(){
      var row=document.getElementById(b.dataset.ev); if(!row) return;
      var open=row.classList.contains('open');
      btns.forEach(function(o){
        var r=document.getElementById(o.dataset.ev);
        if(r){r.classList.remove('open');} o.setAttribute('aria-expanded','false');
      });
      if(!open){ row.classList.add('open'); b.setAttribute('aria-expanded','true'); }
    });
  });
})();

/* galeria hero: miniatura przelacza duze zdjecie */
(function(){
  var stage=document.getElementById('mdjStage');
  var ths=[].slice.call(document.querySelectorAll('.mdj .rail [data-gal]'));
  if(!stage||!ths.length) return;
  ths.forEach(function(t){
    t.addEventListener('click',function(){
      var src=t.getAttribute('data-gal'); if(!src) return;
      ths.forEach(function(o){o.classList.remove('on')});
      t.classList.add('on');
      stage.removeAttribute('srcset'); stage.removeAttribute('sizes');
      stage.src=src;
    });
  });
})();
});

/* ---- HAMBURGER (02.09) ---- */
(function(){
  var b=document.getElementById('mdjBurger'), d=document.getElementById('mdjDrawer');
  if(!b||!d) return;
  function shut(){ d.hidden=true; b.setAttribute('aria-expanded','false'); }
  b.addEventListener('click',function(){
    var open=b.getAttribute('aria-expanded')==='true';
    if(open){ shut(); } else { d.hidden=false; b.setAttribute('aria-expanded','true'); }
  });
  /* klikniecie linku zamyka panel - inaczej po powrocie z kotwicy zostaje otwarty */
  d.addEventListener('click',function(e){ if(e.target.closest('a')) shut(); });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&b.getAttribute('aria-expanded')==='true'){ shut(); b.focus(); } });
  /* obrot telefonu na landscape > 1080 px zostawialby otwarty panel nad trescia */
  /* 04.09: szuflada dziala na kazdej szerokosci - zamykamy tylko klikiem poza nia */
  document.addEventListener('click',function(e){ if(!d.hidden&&!d.contains(e.target)&&!b.contains(e.target)) shut(); });
})();

}
